<template>
  <v-container fluid class="print-only">
    <table class="report-header">
      <tr>
        <th>
          <img class="logo" :src="logo" alt="Logo CTI Consulting">
        </th>
        <td colspan="2">{{reportTitle}}</td>
      </tr>
      <tr>
        <th>Generated</th>
        <td>{{currentUserDisplayName}}</td>
        <td>{{globaldataDate}} {{globalHoursDate}}</td>
      </tr>
      <tr v-for="criteria in reportCriteriaValue" :key="criteria.key" >
        <th colspan="2">{{criteria.key}}</th>
        <td>{{criteria.value}}</td>
      </tr>
    </table>
  </v-container>
</template>
<script>
import logo from '@/assets/logo.png'
import { getCurrentUser } from '@/lib/authentication'

export default {
  props: [
    'reportTitle',
    'reportCriteria'
  ],
  data: () => ({
    logo,
    globaldataDate: new Date().toDateString(),
    globalHoursDate: new Date().toLocaleTimeString(),
    currentUser: getCurrentUser()
  }),
  computed: {
    currentUserDisplayName () {
      return this.currentUser ? this.currentUser.fullName : null
    },
    reportCriteriaValue () {
      return this.reportCriteria.filter(c => c.value)
    }
  }
}
</script>

<style scoped>
table.report-header {
  width: 100%;
  border-collapse: collapse;
}
table.report-header th, table.report-header td{
  border: 1px solid #9e9e9e;
  padding: 1px;
}
table.report-header th{
  text-align: right;
  padding-right: 8px;
}
table.report-header th {
  width: 150px;
  height: 25px;
}
table.report-header .logo {
  width: 50px;
}
</style>
